import React from "react";

// region Languages
import useTranslation from "@languages/useTranslation";
import { AnnouncementMessages } from "@languages/interfaces";
// endregion Languages
// region Libraries
import { Notifications } from "@libraries/mui/icons";
// endregion Libraries
// region Molecules
import ModalFormDialog from "@molecules/ModalFormDialog";
import NotificationItem from "@molecules/NotificationItem";
// endregion Molecules
// region Store
import { MyAnnouncement } from "src/store/graphql/groups/announcement/query.graphql";
// endregion Store
// region Styles
import * as Styled from "./styles";
// endregion Styles

// region Interfaces
interface NotificationListDialogProps {
  open: boolean;
  announcements: MyAnnouncement[];
  onClose: () => void;
  onItemRead: (id: string) => void;
  onItemExposed: (id: string) => void;
  onCtaClick: (item: MyAnnouncement) => void;
}
// endregion Interfaces

/** "View all notifications" dialog — the complete active list, read and unread. */
const NotificationListDialog: React.FC<NotificationListDialogProps> = ({
  open,
  announcements,
  onClose,
  onItemRead,
  onItemExposed,
  onCtaClick
}) => {

  const { t } = useTranslation();

  return (
    <ModalFormDialog open={open} title={t(AnnouncementMessages.viewAll)} onClose={onClose}>
      <Styled.Content>
        {announcements.length === 0 && (
          <Styled.EmptyState>
            <Notifications />
            <span>{t(AnnouncementMessages.emptyTitle)}</span>
          </Styled.EmptyState>
        )}
        {announcements.map((item) => (
          <NotificationItem
            key={item.id}
            item={item}
            onRead={onItemRead}
            onExposed={onItemExposed}
            onCtaClick={onCtaClick}
          />
        ))}
      </Styled.Content>
    </ModalFormDialog>
  );
};

export default NotificationListDialog;
